import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNullableText',
})
export class FormatNullableTextPipe implements PipeTransform {
  transform(value?: string): string {
    if (value?.length == 0 || !value) {
      return '--';
    }
    return value;
  }
}
